import { gql } from '@apollo/client';

export const USER_FRAGMENT = gql`
  fragment UserFragment on User {
    __typename
    id
    email
    firstName
    lastName
    phone
    account_id
    role
    locale
    timeZone
    isWelcomeScreenClosed
    analyticsConsent
    analyticsConsentAt
    analyticsConsentVersion
    isEmailConfirmed
    settings {
      dashboardSettings {
        showTimer
        showClock
        showDate
        showSeconds
        upcomingJobsWindow
        dashboardMaxListLength
        dashboardShowOnlyNew
      }
    }
  }
`;
